<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
        :disabled="disabled"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="800px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :amzMaterialCode="editFormDialogOptions.code"
        :amzMoqCode="amzMoqCode"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditForm from './edit-form'

export default {
  props: {
    amzMoqCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzMoqMaterialListApi({
          amzMoqCode: this.amzMoqCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('dialog_title_material_edit') || '编辑产品起定量物料明细',
        add: this.$l('dialog_title_material_add') || '新增产品起定量物料明细',
        detail:
          this.$l('dialog_title_material_detail') || '产品起定量物料明细详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
